module.exports = __webpack_public_path__ + "static/AddGrid2-c57daaea7e3a76b21d0c06b2a207c997.png";